import axios from 'axios';
import { Cexs } from '../utils/cexs';

const BASE_URL = 'https://api.mainnet.minepi.com';
const BASE_URL_OWN = 'https://horizon.piscan.io';
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
const api_own = axios.create({
  baseURL: BASE_URL_OWN,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const horizon = {
  // 🔍 Get account details by ID
  getAccountDetails: async (accountId: string) => {
    try {
      const response = await api_own.get(`/accounts/${accountId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching account details:', error);
      // Return default account structure
      return {
        id: accountId,
        balances: [{ asset_type: 'native', balance: '0.0000000' }],
        sequence: '0',
        last_modified_time: new Date().toISOString()
      };
    }
  },

  // 🔍 Get transactions for a specific account
  getAccountTransactions: async (accountId: string, limit = 10) => {
    try {
      const response = await api.get(`/accounts/${accountId}/transactions`, {
        params: {
          limit,
          order: 'desc',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching account transactions:', error);
      // Return empty data structure
      return {
        _embedded: { records: [] },
        _links: { next: { href: '' }, prev: { href: '' } }
      };
    }
  },

  // 🔍 Get latest transactions
  getLatestTransactions: async (link="",limit=20) => {
    try {
      var path=`/transactions?limit=${limit}&order=desc`;
      if (link) {
        path = link.substring(link.indexOf("/transactions"));
      }
      const response = await api_own.get(path);
      return response.data;
    } catch (error) {
      console.error('Error fetching latest transactions:', error);
      // Return empty data structure that matches expected format
      return {
        _embedded: { records: [] },
        _links: { next: { href: '' }, prev: { href: '' } }
      };
    }
  },

  // 🔍 Get ledger by sequence number
  getLedgerBySequence: async (sequence: number) => {
    try {
      const response = await api.get(`/ledgers/${sequence}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ledger:', error);
      // Return default ledger structure
      return {
        id: '',
        sequence: sequence,
        transaction_count: 0,
        successful_transaction_count: 0,
        operation_count: 0,
        closed_at: new Date().toISOString(),
        total_coins: '0',
        fee_pool: '0'
      };
    }
  },
  getTransactionByHash: async (hash: string) => {
    try {
      const response = await api.get(`/transactions/${hash}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching transaction:', error);
      // Return default transaction structure
      return {
        hash: hash,
        successful: false,
        created_at: new Date().toISOString(),
        source_account: '',
        fee_charged: '0',
        operation_count: 0
      };
    }
  },
  getOperationByTxHash: async (hash: string) => {
    try {
      const response = await api.get(`/transactions/${hash}/operations?limit=200&order=asc`);
      return response.data;
    } catch (error) {
      console.error('Error fetching operations:', error);
      // Return empty operations data
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },
  getEffectByTxHash: async (hash: string) => {
    try {
      const response = await api.get(`/transactions/${hash}/effects?limit=200&order=asc`);
      return response.data;
    } catch (error) {
      console.error('Error fetching effects:', error);
      // Return empty effects data
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },

  // 🔍 Get list of ledgers
  getLedgers: async (link="") => {
    try {
      var path='/ledgers?order=desc&limit=20';
      if (link) {
        path = link.substring(link.indexOf("/ledgers"));
      }
      const response = await api_own.get(path);
      return response.data;
    } catch (error) {
      console.error('Error fetching ledgers:', error);
      // Return empty ledgers data
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },

  // 🔍 Get network fee stats
  getFeeStats: async () => {
    try {
      const response = await api_own.get('/fee_stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching fee stats:', error);
      // Return default fee stats
      return {
        last_ledger: '0',
        last_ledger_base_fee: '0',
        ledger_capacity_usage: '0',
        fee_charged: { min: '0', max: '0', mode: '0', p10: '0', p20: '0', p30: '0', p40: '0', p50: '0', p60: '0', p70: '0', p80: '0', p90: '0', p95: '0', p99: '0' },
        max_fee: { min: '0', max: '0', mode: '0', p10: '0', p20: '0', p30: '0', p40: '0', p50: '0', p60: '0', p70: '0', p80: '0', p90: '0', p95: '0', p99: '0' }
      };
    }
  },

  // 🔍 Get all available assets
  getAssets: async (limit = 10) => {
    try {
      const response = await api_own.get('/assets', {
        params: {
          limit,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching assets:', error);
      // Return empty assets data
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },
  getCexData: async () => {
    try {
     
        // Gọi tất cả các API call cùng lúc
        const balancePromises = Cexs.map(async (cex) => {
          try {
            const response = await api_own.get(`/accounts/${cex.Address}`);
            const balance = response.data.balances.find(
              (b: any) => b.asset_type === "native"
            );
            return {
              ...cex,
              Balance: parseFloat(balance?.balance || "0"),
            };
          } catch (error) {
            console.error(`Error fetching balance for CEX ${cex.Name}:`, error);
            // Return CEX with zero balance on error
            return {
              ...cex,
              Balance: 0,
            };
          }
        });
        const updatedCexs = await Promise.all(balancePromises);
        return updatedCexs;
    } catch (error) {
      console.error('Error fetching cex balances:', error);
      // Return original CEXs with zero balances
      return Cexs.map(cex => ({ ...cex, Balance: 0 }));
    }
  },
  //get balance of list address
  getBalances: async (addresses: string[]) => {
    try {
      const balancePromises = addresses.map(async (address) => {
        try {
          const response = await api_own.get(`/accounts/${address}`);
          const balance = response.data.balances.find(
            (b: any) => b.asset_type === "native"
          );
          return {
            Address: address,
            Balance: parseFloat(balance?.balance || "0"),
          };
        } catch (error) {
          console.error(`Error fetching balance for address ${address}:`, error);
          // Return address with zero balance on error
          return {
            Address: address,
            Balance: 0,
          };
        }
      });
      const balances = await Promise.all(balancePromises);
      return balances;
    } catch (error) {
      console.error('Error fetching balances:', error);
      // Return addresses with zero balances
      return addresses.map(address => ({ Address: address, Balance: 0 }));
    }
  },
  
  getLatestBlock: async () => {
    try {
      const response = await api_own.get('');
      return response.data.core_latest_ledger;
    } catch (error) {
      console.error('Error fetching network stats:', error);
      return 0; // Return a default value instead of throwing
    }
  },
  getTps: async () => {
    try {
      const latestBlockData=await api_own.get('/ledgers?order=desc&limit=100');
      let tps=0;
      for (let i = 0; i < latestBlockData.data._embedded.records.length; i++) {
        const element = latestBlockData.data._embedded.records[i];
        tps+=element.successful_transaction_count;
      }
      return tps/500;
    } catch (error) {
      console.error('Error fetching network stats:', error);
      return 0; // Return default value
    }
  },
  getTransactions: async(sequence:string,link="")=>{
    try{
      var path=`/ledgers/${sequence}/transactions?limit=20&order=desc`;
      if (link) {
        path = link.substring(link.indexOf("/ledgers/"));
      }
      const response = await api.get(path);
      return response.data;
    }catch(error){
      console.error('Error fetching transactions:', error);
      // Return empty data structure
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },
  getOperations: async(sequence:string,link="")=>{
    try{
      var path=`/ledgers/${sequence}/operations?limit=20&order=desc`;
      if (link) {
        path = link.substring(link.indexOf("/ledgers/"));
      }
      const response = await api.get(path);
      return response.data;
    }catch(error){
      console.error('Error fetching operations:', error);
      // Return empty data structure
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },
  getEffects: async(sequence:string,link="")=>{
    try{
      var path=`/ledgers/${sequence}/effects?limit=20&order=desc`;
      if (link) {
        path = link.substring(link.indexOf("/ledgers/"));
      }
      const response = await api.get(path);
      return response.data;
    }catch(error){
      console.error('Error fetching effects:', error);
      // Return empty data structure
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },
  getLatestOperations: async (link="",limit = 20) => {
    try {
      var path=`/operations?limit=${limit}&order=desc`;
      if (link) {
        path = link.substring(link.indexOf("/operations"));
      }
      const response = await api_own.get(path);
      return response.data;
    } catch (error) {
      console.error('Error fetching latest operations:', error);
      // Return empty data structure that matches expected format
      return {
        _embedded: { records: [] },
        _links: { next: { href: '' }, prev: { href: '' } }
      };
    }
  },
  getClaimableBalances: async (accountId: string) => {
    try {
      const response = await api_own.get(`/claimable_balances?claimant=${accountId}&limit=100`);
      return response.data;
    } catch (error) {
      console.error('Error fetching claimable balances:', error);
      // Return empty claimable balances data
      return {
        _embedded: { records: [] },
        _links: { self: { href: '' }, next: { href: '' }, prev: { href: '' } }
      };
    }
  },
  getClaimEffect: async (link: string) => {
    try {
      link=link.replace("http://","https://");
      const response = await api_own.get(link);
      const data =response.data._embedded.records.find((record: any) => record.type === 'claimable_balance_claimed')
      if (data) {
        return parseFloat(data.amount);
      }
      return 0;
    } catch (error) {
      console.error('Error fetching claimable balances:', error);
      return 0; // Return 0 as default value
    }
  }
};
